import { useQuery } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import type { UserPreferencesResponse } from "../models/api-types";

/**
 * Hook for fetching user's saved preferences from backend
 * Returns user's size preferences and brand preferences
 */
export const useUserPreferences = () => {
  return useQuery<UserPreferencesResponse>({
    queryKey: ["preferences", "user"],
    queryFn: async () => {
      return await queryService.getUserPreferences();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    retry: 1,
  });
};

